<template>
  <div>
    <div class="py-1 mx-1 rounded" :class="{'bg-whitesmoke': isWhitesmokeBackground, 'bg-transparent': isTransparentBackground}">
      <div class="progress blue" :title="isSmallScoreDataComponent ? dataScore : data" :style="cssVars" :class="{'bg-whitesmoke': isWhitesmokeBackground, 'bg-transparent': isTransparentBackground}">
        <span class="progress-left" :style="cssVars">
          <span class="progress-bar"></span>
        </span>
        <span class="progress-right" :style="cssVars">
          <span class="progress-bar"></span>
        </span>
        <div v-if="isSmallScoreDataComponent" class="progress-value-container pr-2 pl-2">
          <div class="progress-data-score text-truncate" >{{dataScore}}</div>
        </div>
        <div v-if="!isSmallScoreDataComponent" class="progress-value-container pr-2 pl-2">
          <div class="progress-data-value text-truncate" >{{data}}</div>
          <div class="progress-data-score">({{dataScore}})</div>
        </div>
      </div>
      <div v-if="isSmallScoreDataComponent" class="mt-1">
        <div class="small">{{data}}</div>
      </div>
    </div>
  </div>
</template>
<script>

const halfRotateTime = 0.6;

export default {
  name: "ScoredDataComponent",
  components: {},
  props: ["data", "dataScore", "dataScoreMax", "SmallScoredDataComponent", "isTransparentBackground"],
  data() {
    return {
      rotateSpeed: halfRotateTime / 180
    }
  },
  mounted() {
  },
  computed: {
    dataScoreMaxValue: function() {
      if (this.dataScoreMax !== undefined) {
        return this.dataScoreMax;
      } else {
        return 1;
      }
    },
    isSmallScoreDataComponent: function() {
      if (this['SmallScoredDataComponent'] !== undefined) {
        return this['SmallScoredDataComponent'] === true;
      } else {
        return false;
      }
    },
    isWhitesmokeBackground: function() {
      return this.isSmallScoreDataComponent && !this.isTransparentBackground
    },
    progressRotate: function() {
      const returnedProgressRotate = this.dataScore * 360 / this.dataScoreMaxValue;
      return returnedProgressRotate;
    },
    cssVars: function() {
      const progressBarRightRotateDeg = (this.progressRotate > 180) ? 180 : this.progressRotate;
      const progressBarLeftRotateDeg = (this.progressRotate > 180) ? this.progressRotate - 180 : 0;
      let progressBarColor = this.defineProgressBarColorFromRotateDeg(this.progressRotate);
      return {
        '--progressBarRightRotateDeg': `${progressBarRightRotateDeg}deg`,
        '--progressBarRightTransformTime': `${progressBarRightRotateDeg * this.rotateSpeed}s`,
        '--progressBarLeftRotateDeg': `${progressBarLeftRotateDeg}deg`,
        '--progressBarLeftTransformTime': `${progressBarLeftRotateDeg * this.rotateSpeed}s`,
        '--progressBarLeftTransformDelay': `${halfRotateTime}s`,
        '--color': `${progressBarColor}`,
        '--progressSize': `${this.isSmallScoreDataComponent ? '50px' : '114px'}`,
        '--progressBorderSize': `${this.isSmallScoreDataComponent ? '4px' : '8px'}`,
        '--progressValuePaddingTop': `${this.isSmallScoreDataComponent ? '10px' : '30px'}`
      }
    }
  },
  methods: {
    defineProgressBarColorFromRotateDeg: function(deg) {
      if (deg === undefined) {
        return '#1abc9c'; // green
      } else if (deg < 90) {
        return '#ed687c'; // pink
      } else if (deg < 180) {
        return '#fdba04'; // yellow
      } else if (deg < 270) {
        return '#1abc9c'; // green
      } else {
        return '#049dff'; // blue
      }
    }
  }
};
</script>
<style scoped>

.progress{
  /* width: 150px; */
  /* height: 150px; */
  width: var(--progressSize);
  height: var(--progressSize);
  
  /* line-height: 150px; */
  line-height: 25px;
  background: none;
  margin: 0 auto;
  padding-top: 50px;
  box-shadow: none;
  position: relative;
}

.progress:after{
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: var(--progressBorderSize) solid #cccccc;
  position: absolute;
  top: 0;
  left: 0;
}

.progress > span{
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 1;
}

.progress .progress-left{
  left: 0;
}

.progress .progress-bar{
  width: 100%;
  height: 100%;
  background: none;
  border-width: var(--progressBorderSize);
  border-style: solid;
  position: absolute;
  top: 0;

  /* border-color: #1abc9c; */
  border-color: var(--color);
}

.progress .progress-left .progress-bar{
  left: 100%;
  border-top-right-radius: 80px;
  border-bottom-right-radius: 80px;
  border-left: 0;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.progress .progress-right{
  right: 0;
}

.progress .progress-right .progress-bar{
  left: -100%;
  border-top-left-radius: 80px;
  border-bottom-left-radius: 80px;
  border-right: 0;
  -webkit-transform-origin: center right;
  transform-origin: center right;
  /* animation: loading-1 1.8s linear forwards; */
  animation: loading-1 var(--progressBarRightTransformTime) linear forwards;
}

.progress .progress-value{
  width: 90%;
  height: 90%;
  border-radius: 50%;
  background: #44484b;
  font-size: 24px;
  color: #fff;
  line-height: 135px;
  text-align: center;
  position: absolute;
  top: 5%;
  left: 5%;
}

.progress .progress-value-container{
  width: 90%;
  height: 90%;
  border-radius: 50%;
  background: #44484b;
  color: #fff;
  text-align: center;
  position: absolute;
  padding-top: var(--progressValuePaddingTop);
  top: 5%;
  left: 5%;
}

.progress-data-value{
  font-size: 13px;
}

.progress-data-score{
  /*font-size: 0.81rem;*/
  font-size: 12px;
  font-weight: bold;
}


.progress.blue .progress-bar{
  /* border-color: #049dff; */
  border-color: var(--color);
}

.progress.blue .progress-left .progress-bar{
  /* animation: loading-2 1.5s linear forwards 1.8s; */
  /* animation: loading-2 var(--progressBarLeftTransformTime) linear forwards 1.8s; */
  animation: loading-2 var(--progressBarLeftTransformTime) linear forwards var(--progressBarLeftTransformDelay);
}

.progress.yellow .progress-bar{
  border-color: #fdba04;
}

.progress.yellow .progress-left .progress-bar{
  animation: loading-3 1s linear forwards 1.8s;
}

.progress.pink .progress-bar{
  border-color: #ed687c;
}

.progress.pink .progress-left .progress-bar{
  animation: loading-4 0.4s linear forwards 1.8s;
}

.progress.green .progress-bar{
  border-color: #1abc9c;
}

.progress.green .progress-left .progress-bar{
  animation: loading-5 1.2s linear forwards 1.8s;
}

@keyframes loading-1{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        /* -webkit-transform: rotate(180deg); */
        /* transform: rotate(180deg); */
        -webkit-transform: rotate(var(--progressBarRightRotateDeg));
        transform: rotate(var(--progressBarRightRotateDeg));
    }
}

@keyframes loading-2{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        /* -webkit-transform: rotate(144deg); */
        /* transform: rotate(144deg); */
        -webkit-transform: rotate(var(--progressBarLeftRotateDeg));
        transform: rotate(var(--progressBarLeftRotateDeg));
    }
}

@keyframes loading-3{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
}

@keyframes loading-4{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(36deg);
        transform: rotate(36deg);
    }
}

@keyframes loading-5{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(126deg);
        transform: rotate(126deg);
    }
}
/*
@media only screen and (max-width: 990px){
    .progress{ margin-bottom: 20px; }
}
*/
.bg-whitesmoke {
  background-color: whitesmoke
}

.bg-transparent {
  background-color: transparent
}
</style>